import styled from 'styled-components';

import * as MUI from '@mui/material';
import * as MUILabs from '@mui/lab';
import { Theme } from '../Theme';

export const Pagination = styled(MUI.TablePagination)``;
